import {Table, TableColumn} from 'element-ui'
import { Button, Pagination } from '@/components'
import GhostModal from './ghostModal.vue'
import modifySamplesMutations from "@/graphql/modifySamplesMutations"
import getOwnerSamplesQuery from "@/graphql/getOwnerSamplesQuery"
import createSimMutation from "@/graphql/createSimMutation"
import invokeSimQuery from "@/graphql/invokeSimQuery"
import runAveragesMutation from "@/graphql/runAveragesMutation"

export default {
  name: 'SamplesModal',
  created: function() {
  this.$store.commit('change', { changes: {} })
  },
  mounted: function() {
  },
  components: {
      [Table.name]: Table,
          [TableColumn.name]: TableColumn,
          [Button.name]: Button,
          [Pagination.name]: Pagination,
          GhostModal
            },
  data () {
    return {
    smallScreen: window.innerWidth < 480 ? true : false,
    deleteRaw: false,
    markedAll: false,
    saving: false,
    search: '',
		closable: false,
		defaultPagination: 1,
    modecomponents: {
  "HARAPPAWORLD": [
    "S-Indian",
    "Baloch",
    "Caucasian",
    "NE-Euro",
    "SE-Asian",
    "Siberian",
    "NE-Asian",
    "Papuan",
    "American",
    "Beringian",
    "Mediterranean",
    "SW-Asian",
    "San",
    "E-African",
    "Pygmy",
    "W-African"
  ],
  "EUROGENESK13": [
    "North_Atlantic",
    "Baltic",
    "West_Med",
    "West_Asian",
    "East_Med",
    "Red_Sea",
    "South_Asian",
    "East_Asian",
    "Siberian",
    "Amerindian",
    "Oceanian",
    "Northeast_African",
    "Sub-Saharan"
  ],
  "DODECADK12B": [
    "Gedrosia",
    "Siberian",
    "Northwest African",
    "Southeast Asian",
    "Atlantic Med",
    "North European",
    "South Asian",
    "East African",
    "Southwest Asian",
    "East Asian",
    "Caucasus",
    "Sub Saharan"
  ],
  "GLOBE13": [
    "Siberian",
    "Amerindian",
    "West African",
    "Palaeo African",
    "Southwest Asian",
    "East Asian",
    "Mediterranean",
    "Australasian",
    "Artic",
    "West Asian",
    "North European",
    "South Asian",
    "East African"
  ],
  "K36": [
    "Amerindian",
    "Arabian",
    "Armenian",
    "Basque",
    "Central African",
    "Central Euro",
    "East African",
    "East Asian",
    "East Balkan",
    "East Central Asian",
    "East Central Euro",
    "East Med",
    "Eastern Euro",
    "Fennoscandian",
    "French",
    "Iberian",
    "Indo-Chinese",
    "Italian",
    "Malayan",
    "Near Eastern",
    "North African",
    "North Atlantic",
    "North Caucasian",
    "North Sea",
    "Northeast African",
    "Oceanian",
    "Omotic",
    "Pygmy",
    "Siberian",
    "South Asian",
    "South Central Asian",
    "South Chinese",
    "Volga-Ural",
    "West African",
    "West Caucasian",
    "West Med"
  ]
},
		showNonRawUploadIcons: () => true,
    }
  },
	computed: {
        mode: {
        set: function(value) {
        this.$store.commit('change', {monteMode: value})
        },
        get: function(value) {
        return this.$store.getters.get('monteMode') ? this.$store.getters.get('monteMode') : 'G25'
        }
        },
    activeModal: function() { return this.$store.getters.get('activeModal') },
    tableData: {
    get: function() {
    let data = JSON.parse(JSON.stringify(this.$store.getters.get("editSamples")));
    if ( this.search ) {
    data = data.filter( x =>
    (this.search.split(':').length > 1 && this.search.split(':')[0].toLowerCase() == 'group' && x.customgroup && x.customgroup.toLowerCase() == this.search.split(':')[1].toLowerCase()  ) ||
    (x && x.sample && x.sample.toLowerCase().indexOf(this.search.toLowerCase()) >=0) ||
    (x && x.type ? x.type.toLowerCase().indexOf(this.search.toLowerCase()) >=0 : false) ||
    (x && x.ethnicity ? x.ethnicity.toLowerCase().indexOf(this.search.toLowerCase()) >=0 : false) || 
    (x && x.origin ?  x.origin.toLowerCase().indexOf(this.search.toLowerCase()) >=0 : false) || 
    (x && x.customgroup ?  x.customgroup.toLowerCase().indexOf(this.search.toLowerCase()) >=0 : false)
    )
    }
    return data
    },
    set: function(value) {
    this.$store.commit('change', { editSamples: value  })
    },
    },
    changes: function() { return  this.$store.getters.get('changes') },
    user: function() { return  this.$store.getters.get('user') },
    changed: function() {
    if ( this.changes && this.tableData ) {
    this.tableData.map(x => {
    if ( x && x.generate ) {
    this.deleteRaw = true;
    }
    })
    }
    if (Object.keys(this.changes).length > 0 ) {
    return true
    } else {
    return false;
    }
    },
		pageData: function() {
			var page = this.defaultPagination;
			var start = page * 8 - 8
			var end = start + 8;
			return this.tableData.slice(start, end)
		},
    pages: function() {
    return this.tableData && this.tableData.length > 0 ? Math.ceil(this.tableData.length/8) : 0;
    },
    height: function() {
    let rowsize = this.smallScreen ? 42.5 * 0.75 : 42.5;
    let length = this.$store.getters.get("editSamples").length
    let height = this.search && this.search.length > 0 ? ( length >= 8 ? (8 * rowsize) + 150 :  (length * rowsize) + 150 ) : this.tableData.length >= 8 ? (8 * rowsize) + 150 : this.pageData.length > 0 ?  parseInt((this.pageData.length * 42.5) + 150) : 280;
    return height
    }
		},
  methods: {
        deleteAll() {
        let w = this;
        let action = !w.markedAll ? 'delete' : undefined
        let samples = JSON.parse(JSON.stringify(w.$store.getters.get("editSamples")));
        let changes = {...w.changes}
        samples.forEach( (row, i) => {
        row.action = action;
        changes[i] = row;
        })
        w.tableData = samples;
        w.$store.commit('change', { changes: changes })
        w.markedAll = !w.markedAll
        },
        clearSearch() {
        this.search = ''
        },
        getXLS: () => {
            return new Promise((resolve, reject) => {
                if (!window.XLSX) {
                    let script = document.createElement('script')
                    script.onload = () => {
                        resolve(true)
                    }
                    script.async = true
                    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.15.2/xlsx.core.min.js'
                    document.head.appendChild(script)
                } else {
                    resolve(true)
                }
            })
        },
    uneditable: function(value) {
                if ( value.type === 'RAW' ) {
                var text = `This is a raw ${value.vendor} DNA file and cannot be edited from this interface.`
                } else {
                var text = `This G25 sample was simulated from ${value.simulated && value.simulated !== 'true' ? value.simulated : ''} sample <b>${this.user.username}&nbsp;►&nbsp;${value.sample.replace(/-sim$/,'')}</b> and cannot be edited from this interface.`
                }
                var title = "Not Editable"
                this.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        class: "alert",
                        title: title,
                        text: text
                    }
                })

    },
    addGhost: function() {
    this.$modal.show('ghostmodal', {groupJSON: this.groupJSON, sampleJSON: this.sampleJSON}) },
		feature: function(el) {
            this.$eventBus.$emit('appEvents', {
                exec: 'featureRequest',
                component: 'g25',
                params: el
            })
        },
        writeSheet() {
            if (this.tableData) {
                this.$store.commit('change', {
                    spinner: true
                })
                let data = []
                this.tableData.map( x => {
                let coords = x.coords.split(',');
                if ( x.sample.split('_').length > 1 && x.sample.split('_')[0] === x.customgroup ) {
                x.sample = x.sample.split('_Average').length > 1 ? 'Average' : x.sample.split('_Median').length > 1 ? 'Median' : x.sample
                }
                let sample = { sample: x.customgroup ? x.customgroup + ':' + ( x.outlier ? x.sample + '_outlier' : x.sample ) : x.sample }; 
                if ( this.mode == 'G25' ) {
                sample = { sample: sample.sample + '_scaled' }
                }
                coords.map( (y,i) => {
                if ( this.mode !== 'G25' && this.modecomponents[this.mode] ) {
                sample[this.modecomponents[this.mode][i]] =  parseFloat(y)
                } else {
                sample[`PC${i + 1}`] = parseFloat(y) 
                }
                });
                data.push(sample)
                if ( x.coords2 && this.mode == 'G25' ) {
                let coords2 = x.coords2.split(',');
                if ( x.sample.split('_').length > 1 && x.sample.split('_')[0] === x.customgroup ) {
                x.sample = x.sample.split('_Average').length > 1 ? 'Average' : x.sample.split('_Median').length > 1 ? 'Median' : x.sample
                }
                let sample = { sample: x.customgroup ? x.customgroup + ':' + ( x.outlier ? x.sample + '_outlier' : x.sample ) : x.sample }; 
                coords2.map( (y,i) => {
                if ( this.mode !== 'G25' && this.modecomponents[this.mode] ) {
                sample[this.modecomponents[this.mode][i]] =  parseFloat(y)
                } else {
                sample[`PC${i + 1}`] = parseFloat(y) 
                }
                });
                data.push(sample)
                }
                })
                this.getXLS().then((res) => {
                    var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet(data, {skipHeader:false});
                    //let wbout = XLSX.utils.sheet_to_csv(ws);
                    XLSX.utils.book_append_sheet(wb, ws, "results");
                    XLSX.writeFile(wb, "datasheet.csv", {
                        compression: true
                    });
                    this.$store.commit('change', {
                        spinner: false
                    })
                }).catch(err => {
                    this.$store.commit('change', {
                        spinner: false
                    })
                    console.log(err)
                })
            } else {
                console.log('Nothing to export..')
            }
        },
  save: function() {
  this.closable = true;
  this.saving = true;
  var w = this;
  this.updateSamples()
/*
  setTimeout(function() {
  w.$eventBus.$emit('appEvents', { exec: 'updateSamples', component: 'g25' })
  }, 1000)
  */
  },
  editModal: async function(action, data) {
      var index = data.index;
      let intro = data.intro ? data.intro : false
      delete data.intro;
      let upload = action === 'upload' ? true : false
      this.$modal.show('editsample', { action: action, index: index, upload: upload, intro: intro  });
      },
edit: function(action) {
    this.$modal.show('editsample')
    },
show: function(params) {
var w = this;
var title = params.title ? params.title : 'Alert!'
var text = params.text ? params.text : 'Message received...'
var buttons = [ 
    {
      title: 'Continue',
      default: false,    // Will be triggered by default if 'Enter' pressed.
      handler: () => { w.closable = true; 
      w.$modal.hide('dialog');
      w.closeModal(true);
      } 
    },
    {
      title: 'Cancel',
      default: true,
      handler: () => { w.closable = false;w.$modal.hide('dialog'); } // Button click handler
    }
 ]
this.$modal.show('dialog', {
  title: title,
  text: text,
  class: params.class ? params.class : undefined,
  buttons: buttons
})
},
		log: function(params, row) { 
    if ( params === 'delete' ) { 
    row.action = 'delete';
    let samples = JSON.parse(JSON.stringify(this.$store.getters.get("editSamples")));
    let index = samples.findIndex( x => x.index === row.index)
    samples[index] = row;
    this.tableData = samples;
    var changes = {...this.changes}
    changes[row.sample] = row
    this.$store.commit('change', { changes: changes })
    }
    if ( params === 'undelete' ) { 
    let samples = JSON.parse(JSON.stringify(this.$store.getters.get("editSamples")));
    var index = row.index;
    samples[index].action = undefined;
    var changes = {...this.changes}
    delete changes[samples[index].sample] 
    this.$store.commit('change', { changes: changes })
    this.tableData = samples;
    }
    if ( params === 'save' ) { 
    console.log(this.changes)
    }
    },
		beforeClose: function(event) {
      if (this.closable === false) {
        event.stop()
      } else {
			this.closable = false
			}
    },
		beforeOpen: function(event) {
    this.deleteRaw = false;
    this.markedAll = false
    this.$store.commit('change', { activeModal: 'SamplesModal' })
    this.defaultPagination = 1;
    this.groupJSON = event.params.groupJSON;
    this.sampleJSON = event.params.sampleJSON;
    this.showNonRawUploadIcons = event.params.showNonRawUploadIcons,
    this.saving = false;
    this.$store.commit('change', { changes: {} })
    let customgroups = []
    let mode = event.params.mode ? event.params.mode : this.mode
    var data = JSON.parse(JSON.stringify(this.$store.getters.get("userSamples"))).filter(sample => this.showNonRawUploadIcons ? true : sample.type === 'RAW')
    if (this.showNonRawUploadIcons ) data = data.filter( x => mode == 'G25' ? (x.type === mode || !x.type ) : x.type === mode )
    data.forEach((sample, index) => {
    if ( sample.customgroup && customgroups.findIndex( x => x === sample.customgroup) < 0) customgroups.push(sample.customgroup)
    sample.index = index;
    sample.age = sample.age ? sample.age - 100000 : undefined;
    })
    this.$store.commit('change', { customgroups: customgroups })
    this.tableData = data;
    if ( event.params.add && !event.params.showNonRawUploadIcons ) {
    this.editModal('upload', { intro: event.params.intro})
    } else if ( event.params.add ) {
    this.editModal('add', { intro: event.params.intro})
    }
    },
		closeModal: function(flag) { 
		var closable = flag ? flag : false
    if ( this.changed && !closable ) {
    this.show({ title: 'Are you sure?', text: 'You have unsaved changes, these will be lost if you continue.', class: 'warning' });
    return;
    } else {
    this.closable = true;
    this.defaultPagination = 1;
		this.$modal.hide('SamplesModal') 
    if ( window.ranSampleTour ) {
    delete window.ranSampleTour
    setTimeout(() => {
                this.$eventBus.$emit('appEvents', {
                    exec: 'startTour',
                    component: 'admix',
                    params: 'calc'
                })
                }, 500)
    }
    }
			},
        updateSamples() {
            var w = this;
            var changes = this.$store.getters.get('changes');
            var userSamples = this.$store.getters.get('userSamples');
            var records = []
            Object.keys(changes).forEach(change => {
                if (changes[change].action === 'delete') {
                    if (userSamples.findIndex(sample => sample.sample === change) >= 0) {
                        records.push(changes[change]);
                    }
                } else {
                    records.push(changes[change]);
                }
            })
            async function processChanges() {
                let results = []
                let errors = []
                let runAverages = false
                const sendUpdates = records.map(async record => {
                    var mutation = modifySamplesMutations[record.action];
                    runAverages =  record.customgroup !== null ? true : runAverages
                    if (record.action === 'delete') {
                        var params = {
                            group: w.user.username,
                            sample: record.sample
                        }
                    } else if ( record.action === 'createSim' ) {
                        var params = {
                            sub: w.user.username,
                            id: w.user.username + Date.now(),
                            sample: w.user.username + ':' + record.sample,
                            coords: record.coords,
                            customgroup: record.customgroup && record.customgroup !== "" ? record.customgroup + '-sim'  : null,
                            sim: true,
                            quiet: true,
                            mode: record.type
                        }
                        mutation = 'createSimMutation'
                    } else if ( record.type === 'RAW' ) {
                        var params = {
                            group: w.user.username,
                            owner: w.user.username,
                            sample: record.sample,
                            v2: record.v2,
                            SSE: record.encrypted == 1 ? false : true,
                            entityType: 'user',
                            type: 'RAW',
                            customgroup: record.customgroup && record.customgroup !== "" ? record.customgroup  : null,
                            description: record.description,
                            vendor: record.vendor,
                            object: record.object,
                            bucket: record.bucket,
                            created: parseInt(record.created/1000)
                        }

                    } else {
                        var params = {
                            group: w.user.username,
                            customgroup: record.customgroup && record.customgroup !== "" ? record.customgroup  : null,
                            owner: w.user.username,
                            sample: record.sample,
                            download: record.download,
                            ethnicity: record.ethnicity,
                            age: parseInt(record.age) + 100000,
                            coords: record.coords,
                            coords2: record.coords2,
                            geo: record.geo && record.geo.latitude && record.geo.longitude ? JSON.stringify(record.geo) : null,
                            entityType: 'user',
                            type: record.type ? record.type : w.mode,
                            public: record.public,
                            description: record.description,
                            origin: record.origin
                        }
                    }
                    if ( mutation === 'createSimMutation') {
                        let data = await w.$apollo.query({
                            query: invokeSimQuery,
                            variables: {
                                event: JSON.stringify(params)
                            }
                        })
                        if ( data && data.data && data.data.invokeSim && data.data.invokeSim.status ) {
                                results.push(data.data)
                        console.log(`Simulation created for ${params.sample} (${params.mode})`)
                        } else {
                        console.log(`Simulation failed for ${params.sample} (${params.mode})`, data)
                                errors.push(data)
                        }
                    } else {
                    let data = await w.$apollo.mutate({
                            mutation: mutation,
                            variables: {
                                input: params
                            }
                        })
                            if (data && data.data) {
                                results.push(data.data)
                                console.log('done', params.sample, mutation);
                            } else {
                                errors.push(data)
                            }
                            }
                })
                try {
                let updated = await Promise.all(sendUpdates);
                }
                        catch(err)  {
                            //w.$sentry.captureException(err);
                            console.log(err)
                        }
                let customgrouped = {}
                records.map( x => {
                if (x.customgroup) customgrouped[x.customgroup] = true
                })
                if ( Object.keys(customgrouped).length > 0 ) {
                try {
                console.log('trying averages')
                let averaged = await w.$apollo.mutate({ mutation: runAveragesMutation, variables: { params: { group: w.user.username, groups: JSON.stringify(Object.keys(customgrouped)) }}})
                }
                catch (err) {
                console.log(err);
                }
                }
                console.log(`Successfully processed ${records.length} records.`)
                if (results.length === records.length) {
                    var klass = 'alert'
                } else {
                    var klass = 'warning'
                }
                var message = `Processed ${results.length} change(s)`
                var errormsg = errors.length > 0 || results.length < records.length ? `<br/>with ${records.length - results.length} error(s)` : ''
                var text = message + errormsg;
                var title = klass === 'alert' ? 'Success!' : 'Error!'
                w.$eventBus.$emit('appEvents', { exec: 'init', component: 'g25' })
                w.$eventBus.$emit('appEvents', { exec: 'init', component: 'pca' })
                if ( window.ranSampleTour && klass === 'alert' ) {
                delete window.ranSampleTour
                        setTimeout(() => {
                            w.$eventBus.$emit('appEvents', {
                                exec: 'startTour',
                                component: 'admix',
                                params: 'calc'
                            })
                            }, 500)
                } else {
                w.$eventBus.$emit('appEvents', {
                    exec: 'show',
                    component: 'nav',
                    params: {
                        class: klass,
                        title: title,
                        text: text
                    }
                })
                }
                w.$modal.hide('SamplesModal')
                //w.init()
            }
            processChanges();
        },
          init: function() {
            let w = this;
            w.$apollo.query({
                    query: getOwnerSamplesQuery,
                    variables: {
                        owner: w.user.username
                    },
                    fetchPolicy: 'network-only'
                })
                .then(data => {
                    if (data && data.data && data.data.queryGenoplotsamplesByOwnerIndex && data.data.queryGenoplotsamplesByOwnerIndex.items && data.data.queryGenoplotsamplesByOwnerIndex.items.length > 0) {
                        var samples = data.data.queryGenoplotsamplesByOwnerIndex.items
                        samples.forEach((sample, index) => {
                            sample.index = sample.group + ':' + sample.sample
                            sample.type = sample.type ? sample.type : 'G25',
                            sample.class = 'default user'
                        })
                        this.$store.commit('change', {
                            userSamples: samples
                        })
                        var userSamples = [{
                            group: w.user.username,
                            samples: samples
                        }]
                        this.userSamples = userSamples
                    } else {
                        console.log(`No samples associated with ${w.user.username} found`);
                        var userSamples = [{
                            group: w.user.username,
                            samples: []
                        }]
                        this.userSamples = userSamples
                        this.$store.commit('change', {
                            userSamples: []
                        })
                    }
                    console.log('new samples', samples);
                w.$modal.hide('SamplesModal')
                })
                .catch(error => {
                    console.log('getOwnerSamples', error);
                w.$modal.hide('SamplesModal')
                });
                }
          }
}
